import { useSettingsAdmSideBarMenu } from './hooks/use-settings-menu-adm.hook';
import { SideMenuList } from './components/side-menu-list';

export const AdmSideMenuList: React.FC = () => {
    const sideBarMenuAdm = useSettingsAdmSideBarMenu();

    return <SideMenuList items={sideBarMenuAdm}></SideMenuList>;
};
